import { NextPage } from 'next'
import PersonalLoanScreen from '../screens/PersonalLoan'
import AppPersonalLoanScreen from '../screens/App-PersonalLoan'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const PersonalLoan: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<PersonalLoanScreen />) : (<AppPersonalLoanScreen />)}
        </>
    )
}
